import { render, staticRenderFns } from "./teacherPage.vue?vue&type=template&id=69080b74"
import script from "./teacherPage.vue?vue&type=script&lang=js"
export * from "./teacherPage.vue?vue&type=script&lang=js"
import style0 from "./teacherPage.vue?vue&type=style&index=0&id=69080b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports